import React from 'react';
import { Query } from "react-apollo";

import { Avatar } from '../user'
import { CommentVote, CommentDelete } from './index'
import { REGX, escapeHTML } from '../../util'
import { clientCredentials } from '../../graphql/queries'

class CommentReplies extends React.Component {

	/*constructor(props) {
		super(props);
	}*/
	
	formatMessage = (body) => {
        body = escapeHTML(body);
        return body.replace(REGX.url, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
    }

	render() {

        if(!this.props.children) {
            return null;
        }

        return (
            <Query query={clientCredentials}>
                {({ data }) => {
                    return (<div className="comment-replies">
                        {this.props.children.map(({ id, body, user, votes, dateCreated, dateEdited }) => {
                            
                            /*let commentDate = formatDate(dateEdited ? dateEdited : dateCreated, true);
                            commentDate += dateEdited ? '*' : '';
                            title={`${user.name} (${commentDate})`}*/
                            
                            //const meta = <button className="button button--icon comment-subicon"><FontAwesomeIcon icon="heart" /></button>;
                            //const meta = <CommentVote commentId={id} votes={votes} />;
                            /*const meta = <CommentActions handleEdit={() => {}} 
                                id={id}
                                votes={votes}
                                user={user} />;*/
                            
                            return (
                                <div key={id} className="card dist-1">
                                    <div className="card-media card-media--inline">
                                        <Avatar user={user} />
                                    </div>
                                    <div className="card-content" dangerouslySetInnerHTML={{__html: this.formatMessage(body)}}>
                                    </div>
                                    {(user.id === data.clientCredentials.id) && 
                                    <CommentDelete commentId={id} buttonClass="button--icon comment-subicon" />
                                    }
                                    <CommentVote commentId={id} votes={votes} />
                                </div>
                            )
                        })}
                    </div>)
                }}
            </Query>
        )
	}
}


export default CommentReplies


// WEBPACK FOOTER //
// ./src/components/comment/CommentReplies.js